module.exports = __webpack_public_path__ + "static/img/wrap2.ea3b4d07.png";